import Blog3MasonryContainer from "../../../../components/pages/blog/blogPage/Blog3Masonry";

const Blog3Masonry = () => {
  return <Blog3MasonryContainer />;
};

export default Blog3Masonry;
